import { LockOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../stores/auth.store';
import './RegisterForm.scss';
import { signInPath } from '../../routes';

interface FormValues {
  email: string;
  username: string;
  password: string;
  confirm: string;
}

const RegisterForm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<FormValues>();
  const register = useAuthStore((state) => state.register);
  const checkToken = useAuthStore((state) => state.checkToken);
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values: FormValues) => {
    try {
      // Register and get tokens
      await register(values.username, values.password, values.email);

      // Check token to get user info
      const isValid = await checkToken();
      if (!isValid) {
        throw new Error('Token no válido tras el registro');
      }
      messageApi.success('Registrado exitosamente');
      navigate(signInPath);
    } catch (error) {
      console.error('Error de registro:', error);
      messageApi.error('No se pudo registrar. Por favor, inténtelo de nuevo.');
    }
  };

  return (
    <div>
      {contextHolder}
      <Form<FormValues> form={form} name="register" onFinish={onFinish} className={'RegisterForm'} scrollToFirstError>
        {/* Email */}
        <Form.Item
          name="email"
          rules={[
            { type: 'email', message: '!Por favor, introdzca un correo electrónico válido!' },
            { required: true, message: '!Por favor, introdzca su correo electrónico válido!' },
          ]}
        >
          <Input prefix={<MailOutlined className="site-form-item-icon" />} type="email" placeholder="Email" />
        </Form.Item>

        {/* Username */}
        <Form.Item
          name="username"
          rules={[
            { required: true, message:'!Por favor ingrese su nombre de usuario!' },
            { min: 3, message: '¡El nombre de usuario debe tener al menos 3 caracteres!' },
          ]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />} type="text" placeholder="Nombre de usuario" />
        </Form.Item>

        {/* Password */}
        <Form.Item
          name="password"
          rules={[
            { required: true, message: 'Please input your password!' },
            { min: 6, message: 'Password must be at least 6 characters!' },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Contraseña"
          />
        </Form.Item>

        {/* Confirm Password */}
        <Form.Item
          name="confirm"
          dependencies={['password']}
          hasFeedback
          rules={[
            { required: true, message: 'Please confirm your password!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('¡Las dos contraseñas no coinciden!'));
              },
            }),
          ]}
        >
          <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Confirmación de contraseña" />
        </Form.Item>

        {/* Submit */}
        <Button type="primary" htmlType="submit" className="RegisterPost" block>
          Registrarse
        </Button>

        {/* Login Link */}
        <Form.Item style={{ textAlign: 'center', marginTop: '16px' }}>
          <a href={signInPath} className="register-form-login">
            Ya tienes una cuenta? Inicia sesión
          </a>
        </Form.Item>
      </Form>
    </div>
  );
};

export default RegisterForm;
